import React from 'react';
import classnames from 'classnames/bind';
import styles from './SessionTimeoutDialog.module.scss';
interface Props {
  countdown: any;
  onLogout: any;
  onContinue: any;
  onClose: Function;
  pageData: any;
}
const SessionTimeoutDialog = ({
  countdown,
  onLogout,
  onContinue,
  onClose,
  pageData,
}: Props) => {
  return (
    <>
      <>
        <div className={'modal-overlay is-active'}>
          <div className="modal-dialog">
            <div className="modal-content u-textCenter">
              <a                
                className="modal-close"
                onClick={() => onClose(false)}
              ></a>
              <h3 className={styles.Heading}>
                {pageData?.SessionExpirationHeadingText}
              </h3>
              <p> {pageData?.YouWillbeLoggedOutText} </p>
              <div className={styles.count}>
                <span>{countdown}</span> {pageData?.SecondsText}
              </div>
              <p>{pageData?.DoYouWantContinueText}</p>
              <div className="u-marginTmd u-textCenter">
                <button
                  onClick={() => onContinue()}
                  className="Button u-block w-100 u-marginBxxsm"
                >
                  {pageData?.KeepMeSignedInText}
                </button>
                <button
                  onClick={() => onLogout()}
                  className={classnames(
                    'Button w-100 Button--ghost gray-border u-block',
                    styles.grayborder,
                  )}
                >
                  {pageData?.SignMeOutText}
                </button>
              </div>
            </div>
          </div>
        </div>
      </>
    </>
  );
};

export default SessionTimeoutDialog;
